import { useRecoilValue } from "recoil";
import { Overlay } from "../../OddsCalc/styles";
import {
  MarketingRequestButton,
  MarketingRequestDateBox,
  MarketingRequestDateWrapper,
  MarketingRequestHeader,
  MarketingRequestInputWrapper,
  MarketingRequestWrapper,
} from "../style";
import { userState } from "../../../../recoil/auth";
import { useEffect, useState } from "react";
import {
  MarketingProductDto,
  MarketingProductType,
  requestMarketing,
} from "../../../../api/marketing";
import { enqueueSnackbar } from "notistack";
import DropBox from "../../../../components/drop-box";
import { getYearList } from "../../../../utils/date";

interface MarketingRequestPopupProps {
  setPopup: (v: boolean) => void;
  product?: MarketingProductDto;
}

const MarketingRequestPopup = ({
  setPopup,
  product,
}: MarketingRequestPopupProps) => {
  const user = useRecoilValue(userState);
  const [count, setCount] = useState(0);
  const [memo, setMemo] = useState("");
  const date = new Date();
  const [startMonth, setStartMonth] = useState(date.getMonth() + 1);
  const [startYear, setStartYear] = useState(date.getFullYear());
  const [endMonth, setEndMonth] = useState(date.getMonth() + 1);
  const [endYear, setEndYear] = useState(date.getFullYear());
  const [isStartYearOpen, setStartIsYearOpen] = useState(false);
  const [isStartMonthOpen, setStartIsMonthOpen] = useState(false);
  const [isEndYearOpen, setEndIsYearOpen] = useState(false);
  const [isEndMonthOpen, setIsEndMonthOpen] = useState(false);

  useEffect(() => {
    if (product?.type !== MarketingProductType.PERIOD) return;

    const start = startYear * 12 + startMonth;
    const end = endYear * 12 + endMonth;
    const diff = end - start + 1;

    setCount(diff > 0 ? diff : 0);
  }, [startYear, startMonth, endYear, endMonth, product]);

  const requestProduct = async () => {
    if (!user || !product?.id || !count || !memo) return;

    if (product?.type === MarketingProductType.QUANTITY) {
      if (getPrice() < 1000000) {
        enqueueSnackbar("1,000,000원부터 신청 가능합니다.", {
          variant: "error",
        });
        return;
      }
      if (getPrice() % 1000000 !== 0) {
        enqueueSnackbar("1,000,000원 단위로만 신청 가능합니다.", {
          variant: "error",
        });
        return;
      }
    }

    try {
      const request = {
        userId: user.id,
        productId: product.id,
        count,
        memo,
      };
      await requestMarketing(request);
      alert("신청되었습니다. ");
      setPopup(false);
    } catch (e) {
      console.error(e);
    }
  };

  const getPrice = () => {
    if (!product) return 0;
    const sum = product.price * count;
    return sum;
  };

  return (
    <>
      <Overlay />
      <MarketingRequestWrapper>
        <MarketingRequestHeader>
          <div className="title">마케팅 신청</div>
          <img
            src="/image-web/Icon/Close_gray.svg"
            alt="close"
            onClick={() => setPopup(false)}
          />
        </MarketingRequestHeader>
        {product?.type === MarketingProductType.QUANTITY ? (
          <MarketingRequestInputWrapper>
            <div className="name">횟수를 입력해주세요. </div>
            <input
              type="text"
              inputMode="numeric"
              value={count === 0 ? "" : count}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  setCount(0);
                  return;
                }
                if (!/^-?\d*$/.test(value)) return;
                setCount(+value);
              }}
              placeholder="수량을 입력해주세요. "
            />
            <div className="name">
              결제 금액: {getPrice()?.toLocaleString()}
            </div>
          </MarketingRequestInputWrapper>
        ) : (
          <MarketingRequestDateWrapper>
            <MarketingRequestDateBox>
              <DropBox
                value={startYear}
                setValue={setStartYear}
                label={"년"}
                isOpen={isStartYearOpen}
                setIsOpen={setStartIsYearOpen}
                option={getYearList()}
              />
              <DropBox
                value={startMonth}
                setValue={setStartMonth}
                label={"월"}
                isOpen={isStartMonthOpen}
                setIsOpen={setStartIsMonthOpen}
                option={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
              />
            </MarketingRequestDateBox>
            <div className="date">~</div>
            <MarketingRequestDateBox>
              <DropBox
                value={endYear}
                setValue={setEndYear}
                label={"년"}
                isOpen={isEndYearOpen}
                setIsOpen={setEndIsYearOpen}
                option={getYearList()}
              />
              <DropBox
                value={endMonth}
                setValue={setEndMonth}
                label={"월"}
                isOpen={isEndMonthOpen}
                setIsOpen={setIsEndMonthOpen}
                option={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
              />
            </MarketingRequestDateBox>
          </MarketingRequestDateWrapper>
        )}
        <MarketingRequestInputWrapper>
          <div className="name">요청 매장명을 입력해주세요. </div>
          <textarea
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
            placeholder="내용을 입력해주세요. "
          />
        </MarketingRequestInputWrapper>
        <MarketingRequestButton
          onClick={requestProduct}
          on={count > 0 && memo !== ""}
        >
          결제 신청
        </MarketingRequestButton>
      </MarketingRequestWrapper>
    </>
  );
};
export default MarketingRequestPopup;
